import { render } from "./ReportingConfigurationCard.vue?vue&type=template&id=4b3b2243&ts=true"
import script from "./ReportingConfigurationCard.vue?vue&type=script&lang=ts"
export * from "./ReportingConfigurationCard.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__